import Icon, { IconType } from 'components/atoms/Icon';
import {
  CognitiveMode,
  CognitiveTestActionFragment,
} from 'generated/graphql';
import { FC, useState } from 'react';
import { Button, TextInputField } from '@spotted-zebra-uk/ui-components';
import { cognitiveKindLabel, cognitiveTestLabel } from '../helpers';
import EditCognitiveTestActionModal from './EditCognitiveTestActionModal';

interface IStageCognitiveTestAction {
  action: CognitiveTestActionFragment;
  stageCognitiveMode: CognitiveMode;
  projectId: number;
  disabled?: boolean;
}

const StageCognitiveTestAction: FC<IStageCognitiveTestAction> = ({
  action,
  stageCognitiveMode,
  projectId,
  disabled,
}) => {
  const [isConfigModalOpen, setIsConfigModalOpen] = useState(false);

  const kindLabel = cognitiveKindLabel(action.kind);

  return (
    <div
      className="stage-test-action"
      data-testid="edit-project__stage-cognitive-test-action"
    >
      <Icon
        icon={`${kindLabel.toLowerCase()}InCircleColored` as IconType}
        className="stage-test-action__icon"
      />
      <TextInputField
        id={`cognitive-test-action-${action.id}`}
        disabled
        onChange={() => {}}
        value={cognitiveTestLabel(action.kind)}
        className="stage-test-action__name-label"
      />
      <Button
        variant="secondary"
        size="small"
        className="stage-test-action__config-button"
        data-testid="stage-cognitive-test-action__config-button"
        onClick={() => setIsConfigModalOpen(true)}
        disabled={disabled}
        aria-label={`Configure ${cognitiveTestLabel(action.kind).toLowerCase()}`}
      >
        <Icon
          icon="settings"
          className="stage-test-action__config-button-icon"
        />
      </Button>
      {isConfigModalOpen && (
        <EditCognitiveTestActionModal
          action={action}
          stageCognitiveMode={stageCognitiveMode}
          projectId={projectId}
          onClose={() => setIsConfigModalOpen(false)}
        />
      )}
    </div>
  );
};

export default StageCognitiveTestAction;
